export interface PostDetail {
  id: string;
  category: string;
  title: string;
  author: string;
  date: string;
  views: number;
  content: string;
  comments: Comment[];
}

export interface Comment {
  id: number;
  author: string;
  date: string;
  content: string;
  depth: number;
  replies?: Comment[];
}

export const postDetailData: Record<string, PostDetail> = {
  '1': {
    id: '1',
    category: '검증요청',
    title: 'xx카지노 사이트 검증 요청드립니다',
    author: '먹튀싫어',
    date: '2026.07.03',
    views: 234,
    content: `안녕하세요. 최근에 xx카지노라는 사이트를 알게 되어 이용해보려고 합니다.

그런데 검색해보니 관련 정보가 너무 부족해서 스카연에 검증을 요청드립니다.

해당 사이트는 최근 3개월 전에 오픈했다고 하는데, 도메인 등록일자를 확인해보니 한 달도 안 된 것 같습니다.

또한 고객센터와 통화했을 때 보증금에 대한 명확한 답변을 받지 못했습니다.

혹시 이 사이트에 대해 알고 계신 분이나 이용해보신 분 있으시면 정보 공유 부탁드립니다.

감사합니다.`,
    comments: [
      { id: 1, author: '검증마스터', date: '2026.07.03 14:32', content: '도메인 등록일자가 한 달도 안 됐다면 일단 의심해보셔야 합니다. 신규 사이트는 충분한 검증 기간을 두고 접근하시는 게 좋아요.', depth: 0 },
      { id: 2, author: '베테랑', date: '2026.07.03 15:10', content: '저도 비슷한 사이트에서 당한 적이 있어요. 고객센터가 보증금에 대해 명확히 답변 못하면 90% 이상 위험합니다.', depth: 0 },
      { id: 3, author: '먹튀싫어', date: '2026.07.03 15:45', content: '검증마스터님, 베테랑님 조언 감사합니다. 일단 접근하지 않고 더 지켜보겠습니다.', depth: 0 },
      { id: 4, author: '검증마스터', date: '2026.07.03 16:02', content: '네, 그리고 혹시 사이트 주소라도 공유해주시면 저희가 먼저 1차 검증 진행해보겠습니다.', depth: 0 },
      { id: 5, author: '분석가', date: '2026.07.03 17:20', content: '추가로 해당 사이트의 게임 결과값이 비정상적으로 변동된다는 제보도 하나 들어왔습니다. 당분간은 이용 자제하시는 게 좋을 것 같네요.', depth: 0 },
    ],
  },
  '2': {
    id: '2',
    category: '피해사례',
    title: '출금 요청했는데 계속 추가 입금만 요구하네요',
    author: '피해자A',
    date: '2026.07.03',
    views: 567,
    content: `일주일 전부터 골든슬롯이라는 사이트를 이용했는데, 어제 200만원 출금을 신청했습니다.

그런데 오늘 아침에 확인해보니 출금이 거절되었다고 하고, "롤링 조건이 충족되지 않았다"며 추가로 100만원을 더 입금해야 출금이 가능하다고 합니다.

하지만 저는 이미 충분한 금액을 베팅했고, 롤링 조건도 다 채웠다고 생각합니다.

증거 자료:
- 첫 입금: 50만원 (7월 1일)
- 베팅 금액: 총 약 800만원
- 출금 신청: 200만원 (7월 3일)
- 요구된 추가 입금: 100만원

고객센터에 문의하니 "시스템상 그렇다"는 답변만 반복하고 있습니다.

이런 경우 어떻게 대처해야 할까요?`,
    comments: [
      { id: 1, author: '베테랑', date: '2026.07.03 12:15', content: '전형적인 먹튀 수법입니다. 추가 입금 절대 하지 마세요. 입금하면 또 다른 이유로 출금 거절할 가능성이 99%입니다.', depth: 0 },
      { id: 2, author: '피해자B', date: '2026.07.03 12:30', content: '저도 똑같은 패턴으로 당했어요. 결국 400만원까지 입금했다가 사이트가 사라졌습니다... 제발 추가 입금하지 마세요.', depth: 0 },
      { id: 3, author: '운영팀', date: '2026.07.03 13:00', content: '안녕하세요, 스카연 운영팀입니다. 해당 내용은 피해 제보 게시판에도 접수해주시면 더 빠른 처리가 가능합니다. 또한 증거 자료를 잘 보관해주세요.', depth: 0 },
      { id: 4, author: '피해자A', date: '2026.07.03 13:45', content: '네, 방금 피해 제보도 접수했습니다. 추가 입금은 하지 않겠습니다. 조언 감사합니다.', depth: 0 },
      { id: 5, author: '검증팀', date: '2026.07.03 14:30', content: '골든슬롯은 저희 모니터링 리스트에도 올라와 있는 사이트입니다. 곧 공식 검증 결과 발표하겠습니다.', depth: 0 },
    ],
  },
  '3': {
    id: '3',
    category: '정보공유',
    title: '최근 먹튀 사이트 패턴 분석 공유합니다',
    author: '분석가',
    date: '2026.07.03',
    views: 892,
    content: `안녕하세요. 지난 3개월간 접수된 먹튀 사례 100건을 분석한 결과를 공유합니다.

1. 🚨 주요 특징
- 85%가 오픈 6개월 미만의 신규 사이트
- 대부분 "추가 입금"을 요구하는 패턴
- 도메인이 .com, .xyz, .cc 등 해외 도메인 사용

2. 📊 사이트 유형별 분포
- 카지노: 45%
- 슬롯 전문: 30%
- 토토/스포츠: 25%

3. ⚠️ 위험 신호
- 과도한 보너스/이벤트
- 출금 조건이 비현실적으로 복잡
- 고객센터 응대가 불친절하거나 회피적
- 사이트 주소가 자주 변경됨

4. 💡 안전한 이용 팁
- 반드시 보증업체 확인
- 처음에는 소액으로 테스트
- 출금은 자주, 소액으로
- 검증된 커뮤니티에서 정보 확인`,
    comments: [
      { id: 1, author: '초보자', date: '2026.07.03 10:00', content: '와 정말 유익한 정보네요! 처음 이용하는 사람에게 큰 도움이 될 것 같습니다.', depth: 0 },
      { id: 2, author: '슬롯매니아', date: '2026.07.03 10:30', content: '카지노가 45%나 되는군요. 슬롯도 30%라니... 정말 조심해야겠어요.', depth: 0 },
      { id: 3, author: '분석가', date: '2026.07.03 11:00', content: '네, 특히 최근에는 슬롯 전문 사이트가 급증하고 있어서 더 주의가 필요합니다.', depth: 0 },
      { id: 4, author: '운영팀', date: '2026.07.03 11:30', content: '훌륭한 분석 감사합니다. 이 내용은 공지사항으로도 발행하겠습니다.', depth: 0 },
    ],
  },
};

export function getPostById(id: string): PostDetail | undefined {
  return postDetailData[id];
}